import $ from "jquery";
$(function () {
    // Handle upscale button clicks
    $(document).on('click', '.upscale-variant', function(e) {
        e.preventDefault();
        
        const variantUuid = $(this).data('variant-uuid');
        const button = $(this);
        const originalText = button.html();
        
        // Check if button is already disabled
        if (button.prop('disabled')) {
            return;
        }
        
        // Disable button and show loading state
        button.prop('disabled', true);
        button.html('<i class="bi bi-hourglass-split mr-1"></i> Starting...');
        
        // Show progress overlay
        showUpscaleProgress(variantUuid);
        
        // Make AJAX request to start upscaling
        $.ajax({
            url: `/products/${variantUuid}/upscale`,
            method: 'POST',
            headers: {
                'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
            },
            success: function(response) {
                console.log('Upscale started:', response);
                
                // Update progress with job information
                updateUpscaleProgress(response);
                
                // Start reliable polling for status updates
                pollUpscaleStatus(variantUuid, response);
                
                // Re-enable button with different text
                button.prop('disabled', false);
                button.html('<i class="bi bi-check-circle-fill mr-1 text-success"></i> Processing...');
                button.addClass('processing');
                
            },
            error: function(xhr) {
                console.error('Upscale failed:', xhr.responseJSON);
                
                // Show error message
                showUpscaleError(xhr.responseJSON?.error || 'Failed to start upscaling');
                
                // Reset button
                button.prop('disabled', false);
                button.html(originalText);
            }
        });
    });
    
    // Show upscale progress overlay
    function showUpscaleProgress(variantUuid) {
        const progressHtml = `
            <div id="upscale-progress-overlay" class="upscale-progress-overlay">
                <div class="upscale-progress-modal">
                    <div class="upscale-progress-header">
                        <h4><i class="bi bi-zoom-in"></i> Upscaling Images</h4>
                        <button type="button" class="close" onclick="hideUpscaleProgress()">
                            <span>&times;</span>
                        </button>
                    </div>
                    <div class="upscale-progress-body">
                        <div id="upscale-status" class="upscale-status">
                            <div class="upscale-loading">
                                <div class="spinner-border text-primary" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                                <p>Starting upscaling process...</p>
                            </div>
                        </div>
                        <div id="upscale-details" class="upscale-details" style="display: none;">
                            <div class="progress mb-3">
                                <div id="upscale-progress-bar" class="progress-bar" role="progressbar" style="width: 0%"></div>
                            </div>
                            <div id="upscale-info" class="upscale-info"></div>
                        </div>
                    </div>
                </div>
            </div>
        `;
        
        $('body').append(progressHtml);
    }
    
    // Update progress with job information
    function updateUpscaleProgress(response) {
        const statusDiv = $('#upscale-status');
        const detailsDiv = $('#upscale-details');
        const infoDiv = $('#upscale-info');
        
        let statusHtml = '';
        let infoHtml = '';
        
        if (response.parallel_processing && response.jobs) {
            statusHtml = `
                <div class="upscale-success">
                    <i class="bi bi-check-circle-fill text-success"></i>
                    <h5>Upscaling Started Successfully</h5>
                    <p>Processing ${response.image_count} images in ${response.parallel_jobs} parallel jobs</p>
                </div>
            `;
            
            infoHtml = `
                <div class="row">
                    <div class="col-md-6">
                        <strong>Total Images:</strong> ${response.image_count}<br>
                        <strong>Parallel Jobs:</strong> ${response.parallel_jobs}<br>
                        <strong>New Revision:</strong> ${response.new_revision}
                    </div>
                    <div class="col-md-6">
                        <strong>Estimated Time:</strong> ${response.estimated_time_minutes || 'Unknown'} minutes<br>
                        <strong>Status:</strong> <span class="badge badge-info">Processing</span>
                    </div>
                </div>
                <div class="mt-3">
                    <strong>Job Details:</strong>
                    <ul class="list-unstyled">
                        ${response.jobs.map(job => `<li>• ${job.job_name}: ${job.image_count} images</li>`).join('')}
                    </ul>
                </div>
            `;
        } else {
            statusHtml = `
                <div class="upscale-success">
                    <i class="bi bi-check-circle-fill text-success"></i>
                    <h5>Upscaling Started Successfully</h5>
                    <p>Processing ${response.image_count} images</p>
                </div>
            `;
            
            infoHtml = `
                <div class="row">
                    <div class="col-md-6">
                        <strong>Total Images:</strong> ${response.image_count}<br>
                        <strong>Job Name:</strong> ${response.job_name}<br>
                        <strong>New Revision:</strong> ${response.new_revision}
                    </div>
                    <div class="col-md-6">
                        <strong>Estimated Time:</strong> ${response.estimated_time_minutes || 'Unknown'} minutes<br>
                        <strong>Status:</strong> <span class="badge badge-info">Processing</span>
                    </div>
                </div>
            `;
        }
        
        statusDiv.html(statusHtml);
        infoDiv.html(infoHtml);
        detailsDiv.show();
    }
    
    // Reliable status polling that directly checks SageMaker status
    function pollUpscaleStatus(variantUuid, initialResponse) {
        let pollCount = 0;
        const maxPolls = 600; // 50 minutes at 5-second intervals (increased from 10 minutes)
        const pollInterval = 5000; // 5 seconds
        
        function poll() {
            pollCount++;
            
            $.ajax({
                url: `/api/v2/products/${variantUuid}/upscaling_progress`,
                method: 'GET',
                success: function(response) {
                    console.log('Status check:', response);
                    
                    if (response.status === 'processing') {
                        // Update progress display
                        updateUpscaleProgressReliable(response);
                        
                        // Continue polling
                        if (pollCount < maxPolls) {
                            setTimeout(poll, pollInterval);
                        } else {
                            // Show a more informative message when polling times out but job is still processing
                            showUpscaleMessage('Upscaling is still in progress. You can close this dialog and check back later, or refresh the page to continue monitoring.');
                        }
                    } else if (response.status === 'completed') {
                        // Success!
                        showUpscaleSuccess('Upscaling completed successfully!');
                        
                        // Reload the 360° view after a short delay
                        setTimeout(function() {
                            location.reload();
                        }, 2000);
                        
                    } else if (response.status === 'failed') {
                        // Failed
                        showUpscaleError(`Upscaling failed: ${response.message}`);
                        
                    } else if (response.status === 'error') {
                        // Error checking status
                        showUpscaleError(`Status check error: ${response.message}`);
                        
                    } else if (response.status === 'unknown') {
                        // No tracking data found
                        showUpscaleMessage('No upscaling data found. The job may have completed or failed. Please refresh the page to check the current status.');
                        
                    } else {
                        // Unknown status
                        console.warn('Unknown status response:', response);
                        showUpscaleError('Unable to determine upscaling status');
                    }
                },
                error: function(xhr) {
                    console.error('Status check failed:', xhr);
                    
                    // Continue polling on error (network issues, etc.)
                    if (pollCount < maxPolls) {
                        setTimeout(poll, pollInterval);
                    } else {
                        showUpscaleMessage('Unable to check upscaling status. You can close this dialog and check back later, or refresh the page to continue monitoring.');
                    }
                }
            });
        }
        
        // Start polling
        setTimeout(poll, pollInterval);
    }

    // Update progress display with reliable status data
    function updateUpscaleProgressReliable(response) {
        const progressOverlay = $('#upscale-progress-overlay');
        const progressBar = progressOverlay.find('.progress-bar');
        const statusText = progressOverlay.find('.status-text');
        const detailsText = progressOverlay.find('.details-text');
        
        if (response.status === 'processing') {
            const progress = response.progress || 0;
            
            // Smooth progress animation
            const currentWidth = parseFloat(progressBar.css('width')) / progressBar.parent().width() * 100;
            const targetWidth = progress;
            
            // Only animate if there's a significant change (more than 1%)
            if (Math.abs(targetWidth - currentWidth) > 1) {
                progressBar.stop().animate({
                    width: targetWidth + '%'
                }, {
                    duration: 500,
                    step: function(now) {
                        progressBar.attr('aria-valuenow', Math.round(now));
                    }
                });
            } else {
                progressBar.css('width', progress + '%').attr('aria-valuenow', progress);
            }
            
            // Add visual feedback based on progress
            progressBar.removeClass('progress-slow progress-steady progress-fast');
            if (progress < 30) {
                progressBar.addClass('progress-slow');
            } else if (progress < 70) {
                progressBar.addClass('progress-steady');
            } else {
                progressBar.addClass('progress-fast');
            }
            
            if (response.running_jobs && response.running_jobs.length > 0) {
                const runningJob = response.running_jobs[0]; // Show first running job
                statusText.text(`Processing batch ${runningJob.batch}/${response.total_jobs} (${progress.toFixed(1)}%)`);
                detailsText.text(`Job: ${runningJob.job_name} - ${runningJob.progress}% complete`);
            } else {
                statusText.text(`Processing (${progress.toFixed(1)}%)`);
                detailsText.text(`${response.completed_jobs}/${response.total_jobs} jobs completed`);
            }
            
            // Add estimated time remaining if available
            if (response.estimated_time) {
                detailsText.text(detailsText.text() + ` • Est. ${response.estimated_time} remaining`);
            }
        }
    }

    // Show success message
    function showUpscaleSuccess(message) {
        const statusDiv = $('#upscale-status');
        statusDiv.html(`
            <div class="upscale-success">
                <i class="bi bi-check-circle-fill text-success"></i>
                <h5>Success!</h5>
                <p>${message}</p>
            </div>
        `);
        
        // Auto-hide after 5 seconds
        setTimeout(hideUpscaleProgress, 5000);
    }
    
    // Show error message
    function showUpscaleError(message) {
        const statusDiv = $('#upscale-status');
        statusDiv.html(`
            <div class="upscale-error">
                <i class="bi bi-x-circle-fill text-danger"></i>
                <h5>Error</h5>
                <p>${message}</p>
            </div>
        `);
    }
    
    // Show info message
    function showUpscaleMessage(message) {
        const statusDiv = $('#upscale-status');
        statusDiv.html(`
            <div class="upscale-info">
                <i class="bi bi-info-circle-fill text-info"></i>
                <h5>Information</h5>
                <p>${message}</p>
                <div class="mt-3">
                    <button type="button" class="btn btn-secondary" onclick="hideUpscaleProgress()">
                        Close Dialog
                    </button>
                </div>
            </div>
        `);
    }
    
    // Hide progress overlay
    window.hideUpscaleProgress = function() {
        $('#upscale-progress-overlay').remove();
        
        // Reset upscale button if it's in processing state
        $('.upscale-variant.processing').each(function() {
            $(this).removeClass('processing');
            $(this).html('<i class="bi bi-zoom-in mr-1"></i> Upscale');
        });
    };
}); 